/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiCustomListsDtoCustomListHistoryChangeDto } from './WebApiCustomListsDtoCustomListHistoryChangeDto';
import {
    WebApiCustomListsDtoCustomListHistoryChangeDtoFromJSON,
    WebApiCustomListsDtoCustomListHistoryChangeDtoFromJSONTyped,
    WebApiCustomListsDtoCustomListHistoryChangeDtoToJSON,
} from './WebApiCustomListsDtoCustomListHistoryChangeDto';
import type { WebApiCustomListsDtoMemberConnectionChangeDto } from './WebApiCustomListsDtoMemberConnectionChangeDto';
import {
    WebApiCustomListsDtoMemberConnectionChangeDtoFromJSON,
    WebApiCustomListsDtoMemberConnectionChangeDtoFromJSONTyped,
    WebApiCustomListsDtoMemberConnectionChangeDtoToJSON,
} from './WebApiCustomListsDtoMemberConnectionChangeDto';
import type { WebApiModelsEnumerationTypesHistoryType } from './WebApiModelsEnumerationTypesHistoryType';
import {
    WebApiModelsEnumerationTypesHistoryTypeFromJSON,
    WebApiModelsEnumerationTypesHistoryTypeFromJSONTyped,
    WebApiModelsEnumerationTypesHistoryTypeToJSON,
} from './WebApiModelsEnumerationTypesHistoryType';

/**
 * 
 * @export
 * @interface WebApiCustomListsDtoCustomListHistoryDto
 */
export interface WebApiCustomListsDtoCustomListHistoryDto {
    /**
     * 
     * @type {number}
     * @memberof WebApiCustomListsDtoCustomListHistoryDto
     */
    id?: number;
    /**
     * 
     * @type {Date}
     * @memberof WebApiCustomListsDtoCustomListHistoryDto
     */
    date?: Date;
    /**
     * 
     * @type {string}
     * @memberof WebApiCustomListsDtoCustomListHistoryDto
     */
    entityId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiCustomListsDtoCustomListHistoryDto
     */
    entityName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiCustomListsDtoCustomListHistoryDto
     */
    createdByName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiCustomListsDtoCustomListHistoryDto
     */
    customListId?: number | null;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesHistoryType}
     * @memberof WebApiCustomListsDtoCustomListHistoryDto
     */
    type?: WebApiModelsEnumerationTypesHistoryType;
    /**
     * 
     * @type {Array<WebApiCustomListsDtoCustomListHistoryChangeDto>}
     * @memberof WebApiCustomListsDtoCustomListHistoryDto
     */
    changes?: Array<WebApiCustomListsDtoCustomListHistoryChangeDto> | null;
    /**
     * 
     * @type {Array<WebApiCustomListsDtoMemberConnectionChangeDto>}
     * @memberof WebApiCustomListsDtoCustomListHistoryDto
     */
    memberConnectionChanges?: Array<WebApiCustomListsDtoMemberConnectionChangeDto> | null;
}

/**
 * Check if a given object implements the WebApiCustomListsDtoCustomListHistoryDto interface.
 */
export function instanceOfWebApiCustomListsDtoCustomListHistoryDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiCustomListsDtoCustomListHistoryDtoFromJSON(json: any): WebApiCustomListsDtoCustomListHistoryDto {
    return WebApiCustomListsDtoCustomListHistoryDtoFromJSONTyped(json, false);
}

export function WebApiCustomListsDtoCustomListHistoryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiCustomListsDtoCustomListHistoryDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'date': !exists(json, 'date') ? undefined : (new Date(json['date'])),
        'entityId': !exists(json, 'entityId') ? undefined : json['entityId'],
        'entityName': !exists(json, 'entityName') ? undefined : json['entityName'],
        'createdByName': !exists(json, 'createdByName') ? undefined : json['createdByName'],
        'customListId': !exists(json, 'customListId') ? undefined : json['customListId'],
        'type': !exists(json, 'type') ? undefined : WebApiModelsEnumerationTypesHistoryTypeFromJSON(json['type']),
        'changes': !exists(json, 'changes') ? undefined : (json['changes'] === null ? null : (json['changes'] as Array<any>).map(WebApiCustomListsDtoCustomListHistoryChangeDtoFromJSON)),
        'memberConnectionChanges': !exists(json, 'memberConnectionChanges') ? undefined : (json['memberConnectionChanges'] === null ? null : (json['memberConnectionChanges'] as Array<any>).map(WebApiCustomListsDtoMemberConnectionChangeDtoFromJSON)),
    };
}

export function WebApiCustomListsDtoCustomListHistoryDtoToJSON(value?: WebApiCustomListsDtoCustomListHistoryDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'date': value.date === undefined ? undefined : (value.date.toISOString()),
        'entityId': value.entityId,
        'entityName': value.entityName,
        'createdByName': value.createdByName,
        'customListId': value.customListId,
        'type': WebApiModelsEnumerationTypesHistoryTypeToJSON(value.type),
        'changes': value.changes === undefined ? undefined : (value.changes === null ? null : (value.changes as Array<any>).map(WebApiCustomListsDtoCustomListHistoryChangeDtoToJSON)),
        'memberConnectionChanges': value.memberConnectionChanges === undefined ? undefined : (value.memberConnectionChanges === null ? null : (value.memberConnectionChanges as Array<any>).map(WebApiCustomListsDtoMemberConnectionChangeDtoToJSON)),
    };
}

